import { TranslationKeys } from '~frontend-common/i18n/english/choices.i18n';

const keys: TranslationKeys = {
  choices: {
    aluminium: 'Aluminium',
    annually: 'Annuellement',
    audibleAlarm: 'Alarme sonore',
    basementOrSemibasement: 'Sous-sol',
    cat: 'Chat',
    condo: 'Condo',
    copper: 'Cuivre',
    legalConsent: "J'accepte",
    detached: 'Détaché',
    dog: 'Chien',
    driverType: {
      mainDriver: 'Principal',
      none: 'Ne conduit pas',
      occasionalDriver: 'Occasionel',
    },
    electric: 'Électrique',
    employed: 'Employé',
    endRowBuilding: "Bâtiment à l'extrémité",
    female: 'Femme',
    fireResistive: 'Résistant au Feu',
    fiveAndHalf: '5 et 1/2',
    forty: '35 000$ - 40 000$',
    fortyfive: 'Plus de 40 000$',
    fourAndHalf: '4 et 1/2',
    fullyFinished: 'Oui et il est 100% fini',
    garage: {
      hasLivingSpace: {
        false: 'Non',
        true: 'Oui',
      },
      numberOfCars: {
        1: '1',
        2: '2',
        3: '3',
        4: '4 ou plus',
      },
      type: {
        attached: 'Attaché',
        basement: 'Sous-sol',
        builtIn: 'Intégré',
        detached: 'Détaché',
        none: 'Aucun',
      },
    },
    gas: 'Gaz',
    gasFireplace: 'Foyer au gaz',
    groundFloor: 'Rez-de-chaussée',
    groundFloorAndBasement: 'Rez-de-chaussée et sous sol',
    halfFinished: 'Oui et il est 50% fini',
    hotWater: 'Eau chaude',
    house: 'Maison',
    inRowBuilding: 'Bâtiment au milieu',
    insideAndAboveGround: 'À l’intérieur et au dessus du sol',
    insideAndInGround: 'À l’intérieur et encastré dans le sol',
    insuredFor1year: '1 an ou moins',
    insuredFor2years: '2 ans',
    insuredFor3years: '3 ans',
    insuredFor4years: '4 ans',
    insuredFor5yearsAndMore: '5 ans et +',
    linkedBurglarAlarm: 'Alarme antivol centrale installée',
    linkedFireAlarm: 'Alarme incendie centrale installée',
    male: 'Homme',
    many: 'Deux et plus',
    married: 'Marié',
    masonry: 'Maçonnerie',
    monthly: 'Mensuellement',
    zero: 'Aucun',
    two: 'Deux',
    threeOrMore: 'Trois ou plus',
    no: 'Non',
    noBasement: 'Non',
    none: 'Aucun',
    noneRegisterCarOwner: 'Aucun, je suis le seul propriétaire immatriculé',
    notFinished: "Oui et il n'est pas fini",
    notInsured: "Je n'ai pas d'assurance",
    notResponsible: 'Non responsable',
    oil: 'Huile',
    oilFireplace: "Foyer à l'huile",
    oilHeating: 'Huile',
    one: 'Une',
    onlyOne: 'Un seulement',
    other: 'Autre',
    outsideAndAboveGround: 'À l’extérieur et au dessus du sol',
    outsideAndInGround: 'À l’extérieur et encastré dans le sol',
    owner: 'Propriétaire',
    plex: 'Plex',
    pool: {
      type: {
        aboveGround: 'Piscine hors-terre',
        inGround: 'Piscine creusée',
        none: '$t(choices.none)',
      },
    },
    spaAboveGround: 'Spa hors-terre',
    spaInGround: 'Spa creusé',
    responsible: 'Responsable',
    retired: 'Retraité',
    secondAndUp: 'Au dessus du rez-de-chaussée',
    semiDetached: 'Semi-Détaché',
    sherlockAntiTheft: 'Anti voleur Sherlock',
    sixAndMore: '6 et 1/2 ou plus',
    smokeDetector: 'Détecteur de fumée installé',
    smokeFreeHousehold: 'Aucun fumeur dans mon ménage',
    stone: 'Pierre',
    stuco: 'Stuc / Aggrégat',
    student: 'Étudiant',
    studio: 'Studio ou 1 et 1/2',
    tagTracking: 'Système de repérage Tag',
    tenant: 'Locataire',
    thirty: '25 000$ - 30 000$',
    thirtyfive: '30 000$ - 35 000$',
    threeAndHalf: '3 et 1/2',
    twenty: 'Moins de 20 000$',
    twentyfive: '20 000$ - 25 000$',
    twoAndHalf: '2 et 1/2',
    twoAndMore: '2 ou plus',
    unemployed: 'Chômage',
    universityDegree: 'Diplôme universitaire',
    vinyl: 'Vinyle',
    wood: 'Bois',
    woodBurningStove: 'Poêle à bois',
    woodFireplace: 'Foyer au bois',
    workFullTime: 'Emploi à temps plein / travailleur autonome',
    workPartTime: 'Emploi à temps partiel',
    yes: 'Oui',
    sawdust: 'Bran de scie',
    uffi: "Mousse isolante d'Urée-Formaldéhyde (MIUF)",
    mineralWool: 'Laine minérale',
    fiberglass: 'Fibre de verre',
  },
};

export default keys;
